import styled from 'styled-components'

import { colors } from '../../../module/colors'
import { size_4 } from '../../../module/style-variables'

const dotSize = '16px'

export const ProgressDotsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: ${size_4};
`

export const ProgressDot = styled.div`
  width: ${dotSize};
  height: ${dotSize};
  border-radius: ${dotSize};
  background-color: ${props => (props.active ? colors.primary : 'white')};
`



// WEBPACK FOOTER //
// ./src/component/_presentational/ProgressDots/ProgressDots-styled.js